import apiClient from './api';

export interface MiniProgramBannerItem {
  url: string;
  fileId: string;
  sort: number;
  path?: string;
}

export interface MiniProgramSupportFaqItem {
  question: string;
  answer: string;
  sort: number;
}

export interface MiniProgramUserConfig {
  id?: string;
  loginLogo: string;
  loginLogoFileId: string;
  loginBrandName: string;
  loginTitle: string;
  loginDescription: string;
  userAgreement: string;
  privacyPolicy: string;
  homeBanners: MiniProgramBannerItem[];
  advertisementBanners: MiniProgramBannerItem[];
  orderPurchaseAgreement: string;
  supportPhone: string;
  supportWechat: string;
  supportHelpText: string;
  supportFaqs: MiniProgramSupportFaqItem[];
  partnerMiniProgramAppId: string;
  partnerMiniProgramPath: string;
  enabled: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const getMiniProgramUserConfig = () =>
  apiClient.get<MiniProgramUserConfig>('/mini-program-user-config');

export const saveMiniProgramUserConfig = (data: MiniProgramUserConfig) =>
  apiClient.put<MiniProgramUserConfig>('/mini-program-user-config', data);
